export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./requirementsTable.vue?vue&type=template&id=63511088&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/pages/RoadSinisters/CloseProject/requirementsTable.vue?vue&type=template&id=63511088&scoped=true
// module id = 1981
// module chunks = 31